import React, { useState } from 'react'
import { UploadFile } from 'antd/lib/upload/interface'
import { Modal, Select } from 'antd'
import { CANProvinces } from '@getgreenline/companies'
import { GlobalCatalogUploadDropzone } from './GlobalCatalogUploadDropzone'

const { Option } = Select

interface Props {
  provinces: { name: string; value: CANProvinces }[]
  onModalClose: () => void
  onFileDrop: (selectedProvince: CANProvinces, file: UploadFile) => void
}

export function GlobalCatalogUploadModal({ provinces, onModalClose, onFileDrop }: Props) {
  const [province, setProvince] = useState<CANProvinces | null>(null)

  return (
    <Modal
      title='Upload Change Set'
      visible={true}
      maskClosable={false}
      width={620}
      onCancel={onModalClose}
    >
      {!province ? (
        <div>
          <Select<CANProvinces>
            placeholder='Select a province'
            onChange={(value) => setProvince(value)}
            style={{ width: '50%' }}
          >
            {provinces.map((province, index) => (
              <Option key={`${province.value}-${index}`} value={`${province.value}`}>
                {province.name}
              </Option>
            ))}
          </Select>
        </div>
      ) : (
        <GlobalCatalogUploadDropzone onDrop={(file) => onFileDrop(province, file)} />
      )}
    </Modal>
  )
}
